import { render } from "./ConfigMaster.vue?vue&type=template&id=1466e994"
import script from "./ConfigMaster.vue?vue&type=script&lang=js"
export * from "./ConfigMaster.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__